import XLSX from "xlsx";
import { mapGetters } from "vuex";
import moment from "moment";
import { countries } from "@/config/data";

export default {
  computed: {
    ...mapGetters(["permissions", "screens", "permissionKeys"]),
  },
  methods: {
    scrollIntoView(ref) {
      if (ref) {
        this.$nextTick(() => {
          this.$refs[ref].$el.scrollIntoView({
            block: "center",
            scrollBehavior: "smooth",
          });
        });
      }
    },
    downloadXLSX(data, name) {
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, name);
      XLSX.writeFile(new_workbook, name + ".xlsx");
    },
    can(key) {
      if (Array.isArray(key)) {
        return this.permissions.some((p) => key.includes(p));
      } else {
        return this.permissions.includes(key);
      }
    },
    findChild(key) {
      let result = "";
      key.forEach((value) => {
        if (value !== undefined) {
          value.map((i) => {
            let k = i.permissionKey;
            if (this.permissionKeys.includes(k)) {
              return (result = true);
            } else {
              return (result = false);
            }
          });
        }
      });
      return result;
    },
    canScreen(key, child, item) {
      this.checked = false;
      if (key == undefined) {
        return true;
      } else {
        if (Array.isArray(key)) {
          if (child !== undefined) {
            // one of them have sub childers
            let allUndefined = child.every((item) => item === undefined);
            if (allUndefined == false) {
              if (this.findChild(child) == false) {
                return this.permissionKeys.some((p) => key.includes(p));
              } else {
                return this.findChild(child);
              }
            } else {
              if (item.category !== undefined && item.category !== null) {
                if (item.category == this.$store.getters.user.user_category) {
                  return this.permissionKeys.some((p) => key.includes(p));
                } else {
                  return false;
                }
              } else {
                return this.permissionKeys.some((p) => key.includes(p));
              }
            }
          }
          if (child == undefined) {
            // means no sub child exists
            return this.permissionKeys.some((p) => key.includes(p));
          }
        } else {
          if (item !== undefined && item !== null) {
            if (item.category !== undefined && item.category !== null) {
              if (item.category == this.$store.getters.user.user_category) {
                return this.permissionKeys.includes(key);
              } else {
                return false;
              }
            } else {
              return this.permissionKeys.includes(key);
            }
          } else {
            return this.permissionKeys.includes(key);
          }
        }
      }
    },
    fileDownload(res, type) {
      const blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });
      const link = document.createElement("a");

      link.href = URL.createObjectURL(blob);

      if (res.headers["content-disposition"]) {
        link.download = res.headers["content-disposition"]
          .split("filename=")
          .pop();
        link.download = link.download.replace(/['"]+/g, "");
      }

      if (type == "pdf") {
        window.open(link.href, "_blank");
      } else if (type == "image") {
        return link;
      } else {
        link.click();
        URL.revokeObjectURL(link.href);
      }
    },
    fileCSVDownload(res) {
      const blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });
      const link = document.createElement("a");
      link.setAttribute("href", URL.createObjectURL(blob));
      link.setAttribute("download", "export.csv");
      link.click();
      URL.revokeObjectURL(link.href);
    },
    timeInput(time, type) {
      if (time[type]?.length === 2) {
        time[type] += ":";
      }
    },
    getFormattedDate(date) {
      return date && moment(date).isValid()
        ? moment(date).format("ddd DD MMM, YYYY")
        : "";
    },
    isURL(data) {
      if (typeof data === "string") {
        return true;
      }
    },
    displayCountry(code) {
      if (code) return countries[code];
    },
    checkPermission(key) {
      if (key !== undefined) {
        return this.permissionKeys.includes(key);
      } else {
        return true;
      }
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    firstLetterCapital(str) {
      if (str !== null && str !== undefined && str !== "")
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    changeFormat(number) {
      if (number !== undefined && number !== null && number !== "") {
        // Check if the number has non-zero decimal places
        if (Number.isInteger(number)) {
          return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
          });
        } else {
          return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
          });
        }
      }
    },
    changeNumberFormat(number) {
      if (number !== undefined && number !== null && number !== "") {
        // Check if the number has non-zero decimal places
        // return number.toLocaleString("en-US");
        if (Number.isInteger(number)) {
          return number.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            useGrouping: true,
          });
        } else {
          return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            useGrouping: true,
          });
        }
      } else {
        return "";
      }
    },
  },
};
